exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form_loader {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 99;\n\tbackground: rgba(255,255,255,0.4);\n}\n.form_loader .data_loader{\n\tposition: absolute;\n\tleft: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n}\n.loader_wrap {\n  margin: 0 0 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/common/loader/loader.component.css
// module id = ../../../../../src/app/components/common/loader/loader.component.css
// module chunks = main